import React from "react";
import { Redirect } from "react-router-dom";

import { useIsRouteEnabled } from "components/navigation/hooks/useIsRouteEnabled";
import { deriveRedirectTarget, MCS_ROUTE } from "components/router/Routes";

export default function McsView(): JSX.Element {
    const isRouteEnabled = useIsRouteEnabled();

    const target = deriveRedirectTarget(MCS_ROUTE, isRouteEnabled);

    return <Redirect to={target.path} />;
}
